export default class PaginationManager {
    constructor({ items, pageSize }) {
        this.items = [...items];
        this.pageSize = pageSize;
        this.currentPage = 1;
        this.hasUnseenItems = false;
    }

    addItem(node) {
        this.items.unshift(node);
        if (this.currentPage !== 1) {
            this.hasUnseenItems = true;
        }
    }

    getTotalPages() {
        return Math.max(1, Math.ceil(this.items.length / this.pageSize));
    }

    getPageItems(pageNumber) {
        const start = (pageNumber - 1) * this.pageSize;
        return this.items.slice(start, start + this.pageSize);
    }

    goToPage(pageNumber) {
        this.currentPage = Math.max(1, Math.min(pageNumber, this.getTotalPages()));
        if (this.currentPage === 1) {
            this.hasUnseenItems = false;
        }
        return this.getPageItems(this.currentPage);
    }

    isOnFirstPage() {
        return this.currentPage === 1;
    }
}
